/* eslint-disable no-param-reassign */
// eslint-disable-next-line
import lozad from 'lozad';

const lozadObserver = lozad('.lozad', {
    load(el) {

        el.src = el.dataset.src;
        el.onload = () => {

            el.classList.add('js-loaded');

        };

    },
});
lozadObserver.observe();

/**
 * A helper function to observe when an element
 * has been loaded by lozad and run a callback function
 *
 * @param {HTMLElement} target The element to observe
 * @param {Function} callback The callback function
 * @returns {void}
 */
function observeIsLoaded(target, callback) {

    // If the element is already loaded, run the callback
    if (callback && target.classList.contains('js-loaded')) {

        callback();
        return;

    }

    const observerCallback = (mutationList, observer) => {

        mutationList.forEach((mutation) => {

            if (mutation.attributeName === 'class' && mutation.target.classList.contains('js-loaded')) {

                if (callback) {

                    callback();

                }

                observer.disconnect();

            }

        });

    };

    const observer = new MutationObserver(observerCallback);

    observer.observe(target, {
        attributes: true,
    });

}

export default observeIsLoaded;
